import Info3Content from '../components/info/Info3PageContent';

const Info3Page = () => {
  return <Info3Content />;
};

export default Info3Page;